import { createReducer } from '@reduxjs/toolkit';

import types from './types';

type BiometricAuthenticationState = {
  readonly isLoading: boolean;
}

const initialState: BiometricAuthenticationState = {
  isLoading: false,
};

const biometricAuthenticationReducer = createReducer(initialState, (builder) => {
  builder.addCase(types.MOBILE_DEVICE_BIOMETRIC_AUTHENTICATION.REQUEST, (draft) => {
    draft.isLoading = true;
  });

  builder.addCase(types.MOBILE_DEVICE_BIOMETRIC_AUTHENTICATION.SUCCESS, (draft) => {
    draft.isLoading = false;
  });

  builder.addCase(types.MOBILE_DEVICE_BIOMETRIC_AUTHENTICATION.FAILURE, (draft) => {
    draft.isLoading = false;
  });
});

export default biometricAuthenticationReducer;
export {
  BiometricAuthenticationState,
  initialState,
};
